import { createGlobalStyle } from 'styled-components'
import cssReset from './cssReset'
import { colors } from './colors'
import { Sentinel } from '@styles/global/fonts'
import flickity from '@styles/modules/flickity'
import { device } from '@styles/global/breakpoints'
import { deepPurple } from '@styles/themes/darkThemeBeautifulLettering'

export default createGlobalStyle`

  ${cssReset}
  ${flickity}
  
  body{
    font-family: 'Raleway', sans-serif;
    font-weight: 500;
    //letter-spacing: .8px;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: auto;
    color: ${colors.text};
    position: relative;
    
    &.mobileNavOpen{
      overflow-y: hidden;
    }
    
    .lfm2020-h1 {
      margin-bottom: .5em;
      ${Sentinel.semiboldItalic};
      font-size: 38px;
      font-weight: 500;
      line-height: 1.2;
  
      @media ${device.tablet} {
        font-size: 44px;
        max-width: none;
      }
  
      @media ${device.laptop} {
        font-size: 48px;
      }
      @media ${device.laptopL} {
        font-size: 60px;
      }
    }
  }
  
  a{
  	transition: color .3s;
  	will-change: color;
  	&:hover{
  		color: ${colors.primary.pink};
  	}
  }
  p{
    line-height: 28px;
  }
  
  #___gatsby{
  	/* min-height: 100vh; */
    overflow-x: hidden;
  }
  
  // BUTTONS 
  .et-btn-blue {
    background: #525f7f;
    color: #fff;
  }

  .et-btn-plum{
    background: #4D286F;
    color: #fff;
  }

  .et-btn-plum{
    background: #4D286F;
    color: #fff;
  }
  
  .et-btn-green {
    background: #5C8879;
    color: #fff;
  }

  .et-btn-magenta {
    background: #f548f5;
    color: #fff;
    
    &.et-magenta-shadow{
      box-shadow: 0 3px 13px 0px #ff4fff00 !important;
      &:hover{
        box-shadow: 0 3px 15px 0px #ff4fff !important;
      }
    }
  }

  .et-btn-purple {
    background: #20323f;
    color: #fff;
  }
  
  .bold{
    font-weight: 600;
  }
  
  .italic{
    font-style: italic;
  }
  
  .bs-embed-responsive{
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;
    
    &::before{
      display: block;
      content: "";
    }
  }
  
  .bs-embed-responsive-16by9{
    &::before{
      padding-top: 56.25%;
    }
  }
  
  .bs-embed-responsive-item{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .lfm2020-polaroid-single {
    display: flex;
    flex-direction: column;
    position: relative;

    .frame {
      background: #fff;
      position: relative;
      padding: 15px;
      box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
      z-index: 2;
      height: 100%;
      .gatsby-image-wrapper{
        height: 100%;
      }
      &.crop{
        .gatsby-image-wrapper{
          position: absolute !important;
          width: 100%;
        }
      }
    }

    img {
      width: 100%;
      position: relative;
      z-index: 3;
    }
  }

  
`
